import { render, staticRenderFns } from "./table.vue?vue&type=template&id=44bdea84&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=44bdea84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleCard: require('/opt/yamal.ru/src/components/schedule/card.vue').default,ScheduleRow: require('/opt/yamal.ru/src/components/schedule/row.vue').default,RzSimpleTable: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/simple-table/index.vue').default})
